import { OrcamentoIcon } from './OrcamentoUI';
import React from 'react';

// Itens da verificação DL 50/2005 — os mesmos do relatório em PDF
// (backend/routes/dl50.js). Usada no DL50 individual e no DL50 em lote.
export const ITENS_DL50 = [
    { type: 'header', text: 'Requisitos de segurança (Artigos 10º ao 29º, do DL 50/2005)' },
    { id: 1, text: '1. Sistemas de comando' },
    { id: 2, text: '2. Arranque do equipamento' },
    { id: 3, text: '3. Paragem do equipamento' },
    { id: 4, text: '4. Estabilidade e rotura' },
    { id: 5, text: '5. Projecções e emanações' },
    { id: 6, text: '6. Risco de contacto mecânico' },
    { id: 7, text: '7. Iluminação e temperatura' },
    { id: 8, text: '8. Dispositivos e alerta' },
    { id: 9, text: '9. Manutenção do equipamento' },
    { id: 10, text: '10. Riscos eléctricos e de explosão' },
    { id: 11, text: '11. Fontes de alimentação' },
    { id: 12, text: '12. Sistemas de controlo' },
    { id: 13, text: '13. Sinalização de segurança' },
    { type: 'header', text: 'Requisitos complementares dos equipamentos móveis' },
    { id: 14, text: '14. Eq. que transportem trabalhadores / capotamento' },
    { id: 15, text: '15. Eq. transp. trabalhadores / queda objectos' },
    { id: 16, text: '16. Transmissão de energia' },
    { id: 17, text: '17. Equipamentos móveis automotores' },
    { type: 'header', text: 'Requisitos complementares de elevação de cargas' },
    { id: 18, text: '18. Instalação' },
    { id: 19, text: '19. Sinalização e marcação de segurança' },
    { id: 20, text: '20. Eq. elevação e transporte de trabalhadores' },
    { type: 'header', text: 'Outros requisitos' },
    { id: 21, text: '21. Manual de instruções em Português' },
    { id: 22, text: '22. Declaração CE de conformidade' },
    { id: 23, text: '23. Outro. Qual?' },
    { type: 'header', text: 'EPI contra quedas em altura — arnês, mosquetões, cordas e fitas (EN 365)' },
    { id: 24, text: '24. Arnês — fitas, costuras, fivelas e argolas de engate' },
    { id: 25, text: '25. Mosquetões / conectores — corpo, patilha e fecho de segurança' },
    { id: 26, text: '26. Cordas de segurança — capa, alma, terminais e absorvedor' },
    { id: 27, text: '27. Fitas / anéis de ancoragem — cortes, desgaste e costuras' },
    { id: 28, text: '28. Marcação legível, dentro da vida útil e sem ter retido quedas' }
];

// Todos os itens em «C» (Conforme): o ponto de partida de cada verificação
export const checklistConforme = () => ITENS_DL50.filter(i => i.id).reduce((acc, i) => {
    acc[`item${i.id}`] = { status: 'C', obs: '' };
    return acc;
}, {});

// EPI contra quedas em altura: que itens de EPI se aplicam a uma ficha, pelo
// nome e, se o nome não disser, pelo tipo (tipo «ARNES» com nome «Mosquetão»
// é só mosquetão). Fitas e cintas de elevação são acessórios de elevação, e as
// fitas métricas, isoladoras ou de sinalização também não são EPI.
const TIPOS_EPI = [
    { id: 24, label: 'Arnês', re: /arn[eê]s/i },
    { id: 25, label: 'Mosquetão', re: /mosquet|conector/i },
    { id: 26, label: 'Corda', re: /corda|linha de vida|talabarte|absorvedor|retr[aá]til/i },
    { id: 27, label: 'Fita', re: /\bfitas?\b|\ban[eé]is\b|\banel\b/i },
];
const ITEM_EPI_GERAL = 28; // marcação e vida útil: qualquer EPI
const EPI_SEM_TIPO = /anti.?queda|queda em altura|\bepi\b/i;
const NAO_EPI = /eleva[cç][aã]o|carga|m[eé]tric|medi[cç][aã]o|isolad|adesiv|sinaliza/i;

export const tiposEpi = (eq) => {
    const nome = eq?.nome || '';
    const tipo = eq?.tipo || '';
    if (eq?.categoria === 'rmm' || NAO_EPI.test(nome) || NAO_EPI.test(tipo)) return [];
    for (const texto of [nome, tipo]) {
        const encontrados = TIPOS_EPI.filter(t => t.re.test(texto));
        if (encontrados.length) return encontrados;
    }
    return EPI_SEM_TIPO.test(`${nome} ${tipo}`) ? TIPOS_EPI : [];
};

// A check-list de partida de uma ficha: num EPI os itens de máquinas (1 a 20)
// e os de EPI de outro tipo ficam «NA»; nas outras fichas, os de EPI.
export const checklistPara = (eq, base) => {
    const tipos = tiposEpi(eq).map(t => t.id);
    const ck = { ...base };
    const na = (id) => { ck[`item${id}`] = { obs: '', ...ck[`item${id}`], status: 'NA' }; };
    if (tipos.length) {
        for (let id = 1; id <= 20; id++) na(id);
        TIPOS_EPI.forEach(t => { if (!tipos.includes(t.id)) na(t.id); });
    } else {
        [...TIPOS_EPI.map(t => t.id), ITEM_EPI_GERAL].forEach(na);
    }
    return ck;
};

const ESTADOS = ['NA', 'C', 'NC'];

const ChecklistDL50 = ({ checklist, onChange }) => {
    const mudar = (id, parcial) => {
        const chave = `item${id}`;
        const atual = checklist[chave];
        onChange({ ...checklist, [chave]: { status: atual?.status, obs: atual?.obs || '', ...parcial } });
    };

    return (
        <div className="dl50-checklist-section" style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
            <div style={{ background: '#f8fafc', padding: '12px 15px', borderBottom: '1px solid #e2e8f0' }}>
                <h3 style={{ margin: 0, fontSize: '0.9rem', color: '#4a5568' }}><OrcamentoIcon name="check" fallback="✅" /> Check-list de Verificação</h3>
            </div>
            <table className="equipamentos-table" style={{ fontSize: '13px' }}>
                <thead>
                    <tr>
                        <th>Item de Verificação (DL 50/2005)</th>
                        <th style={{ width: '50px' }}>NA</th>
                        <th style={{ width: '50px' }}>C</th>
                        <th style={{ width: '50px' }}>NC</th>
                        <th>Data limite corr. / Observações</th>
                    </tr>
                </thead>
                <tbody>
                    {ITENS_DL50.map((item, idx) => (
                        item.type === 'header' ? (
                            <tr key={`h-${idx}`} style={{ background: '#edf2f7' }}>
                                <td colSpan="5" style={{ fontWeight: 'bold', fontSize: '11px', color: '#4a5568' }}>{item.text}</td>
                            </tr>
                        ) : (
                            <tr key={item.id}>
                                <td>{item.text}</td>
                                {ESTADOS.map(s => (
                                    <td key={s} style={{ textAlign: 'center' }}>
                                        <input type="radio" aria-label={`${item.text}: ${s}`}
                                            checked={checklist[`item${item.id}`]?.status === s}
                                            onChange={() => mudar(item.id, { status: s })} />
                                    </td>
                                ))}
                                <td>
                                    <input type="text" aria-label={`${item.text}: observações`}
                                        value={checklist[`item${item.id}`]?.obs || ''}
                                        onChange={(e) => mudar(item.id, { obs: e.target.value })}
                                        style={{ width: '100%', padding: '2px' }} />
                                </td>
                            </tr>
                        )
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ChecklistDL50;
